if (!customElements.get('nuer-discovery')) {
  customElements.define('nuer-discovery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.required = Number(this.dataset.required);
      this.form = this.querySelector('form');
      this.scents = [...this.querySelectorAll('[data-scent]')];
      this.boxes = [...this.querySelectorAll('[data-box]')];
      this.submitButton = this.querySelector('[data-discovery-submit]');
      this.addEventListener('change', () => this.update());
      // Capture runs before Dawn's product-form handler builds FormData.
      this.form.addEventListener('submit', (event) => {
        if (!this.update()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.querySelector('[data-selection-help]').textContent = 'Select five different fragrances and an available box.';
        }
      }, true);
      this.update();
    }

    update() {
      const selected = this.scents.filter((input) => input.checked && !input.hasAttribute('data-unavailable'));
      const box = this.boxes.find((input) => input.checked && !input.disabled);
      const valid = selected.length === this.required && new Set(selected.map((input) => input.value)).size === this.required && !!box;
      this.querySelector('[data-selection-progress]').value = selected.length;
      this.scents.forEach((input) => {
        input.disabled = input.hasAttribute('data-unavailable') || (selected.length >= this.required && !input.checked);
      });
      this.querySelector('[data-selection-count]').textContent = `${selected.length} of ${this.required} selected`;
      this.querySelector('[data-selection-help]').textContent = !box ? 'This discovery set is currently sold out.' : valid ? 'Your set is ready: five 10 ml fragrances.' : `Choose ${Math.max(0, this.required - selected.length)} more fragrance${this.required - selected.length === 1 ? '' : 's'}.`;
      this.submitButton.disabled = !valid;
      if (box) {
        this.querySelector('.product-variant-id').value = box.value;
        this.querySelector('[data-discovery-price]').textContent = box.dataset.price;
        const compare = this.querySelector('[data-discovery-compare]');
        compare.textContent = box.dataset.compare;
        compare.hidden = !box.dataset.compare;
      }
      const properties = this.querySelector('[data-selection-properties]');
      const list = this.querySelector('[data-selection-list]');
      properties.replaceChildren();
      list.replaceChildren();
      selected.forEach((input, index) => {
        const property = document.createElement('input');
        property.type = 'hidden';
        property.name = `properties[Fragrance ${index + 1}]`;
        property.value = `${input.value} — 10 ml`;
        properties.append(property);
        const item = document.createElement('li');
        item.textContent = `${input.value} · 10 ml`;
        list.append(item);
      });
      return valid;
    }
  });
}
